module.exports = __webpack_public_path__ + "static/media/IconTemplates_-32.e3e63b1b.svg";